/**
 * @fileoverview PUT handler for the "/apps/engagement_reports/engagement_report" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsEngagementReportsEngagementReportCacheKeys } from "./constants";
import type {
  PutAppsEngagementReportsEngagementReportProps,
  AppsEngagementReportsEngagementReportResult,
} from "./types";

export const putAppsEngagementReportsEngagementReport = reactQueryMutationAdapter(
  appsEngagementReportsEngagementReportCacheKeys,
  (props: PutAppsEngagementReportsEngagementReportProps): Promise<AppsEngagementReportsEngagementReportResult> => {
    return fetch("/apps/engagement_reports/engagement_report", "PUT", props);
  }
);
